import Settings from "../../../settings";
import {
  data_fetch_api_resource,
  data_create_api_resource,
} from "../../../utils/http_functions";
import { parseJSON } from "../../../utils/misc";
import {
  SUBMIT_INSTALLATION_DATA,
  SUBMIT_PERSON_DATA,
  SUBMIT_CONTRACT_DATA,
  SUBMIT_DUAL_GAS_CONTRACT_DATA,
  SUBMIT_PAYMENT_DATA,
  SUBMIT_CONFIRMATION_DATA,
  SUBMIT_FINISH,
  RECEIVE_CONTRACTATION_CONFIG,
  RECEIVE_DUAL_CONTRACTATION_CONFIG,
  NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST,
  NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE,
  SET_LEAD_ID,
  SET_LEAD_STEP_CURRENT,
  SET_LEAD_INDEX_COMPLETED,
  SET_LEAD_ERRORS,
  SET_LEAD_SUBMIT_REQUEST,
  SET_GAS_LEAD_ID,
  RESET_CONTRACTATION,
} from "../../../constants";
import * as Sentry from "@sentry/react";
import i18n from "@/languages/index";
import { Dispatch } from "redux";
import {
  ElecStepNames,
  ElecStepsFormDataMap
} from "../types/stepsFormData";
import { StepConfirmationFormDataAPI, IStepConfirmationResponseData } from "../types/stepsAPI";
import { ContractationConfigResponse } from "../types/config";
import { LeadErrors } from "../types/steps";

// ----------------------------------------------------------------------------
// Electricity Contractation Form
// ----------------------------------------------------------------------------
export const setLeadSubmitting = () => {
  return {
    type: SET_LEAD_SUBMIT_REQUEST
  }
}

export const setLeadId = (leadId: number) => {
  return {
    type: SET_LEAD_ID,
    payload: {"leadId": leadId}
  }
}

export const setLeadStepCompleted = (stepIndex: number) => {
  return {
    type: SET_LEAD_INDEX_COMPLETED,
    payload: {
      stepIndex
    }
  }
}

export const setLeadCurrentStep = (index: number, name: string) => {
  return {
    type: SET_LEAD_STEP_CURRENT,
    payload: { index, name }
  }
}

export const setLeadsErrors = (data: LeadErrors) => {
  return {
    type: SET_LEAD_ERRORS,
    payload: data
  };
};

export const resetLeadsErrors = () => {
  return async (dispatch: Dispatch) => {
    dispatch(setLeadsErrors({
      badScore: false,
      dniInvalid: false,
      genericError: false
    }))
  }
};

export const checkLeadScore = async (token: string, lead_id: number) => {
  const response = await data_fetch_api_resource(token, `leads/solvencia/${lead_id}`)
    .catch((e) => {
      Sentry.captureException(e);
    });
  if (response?.status === 200) {
    return {badScore: !response.data['scoring']};
  } 
  return {badScore: true};
};

export const checkLeadDNI = async (token: string, lead_id: number) => {
  const response = await data_fetch_api_resource(token, `leads/dni-validation/${lead_id}`)
    .catch((e) => {
      Sentry.captureException(e);
    });
  if (response?.status === 200) {
    return {dniInvalid: !response.data['dni_valid']};
  } 
  return {dniInvalid: true};
};

export const setStepData = <TStepName extends ElecStepNames,>(
  name: TStepName, 
  data: ElecStepsFormDataMap[TStepName]
) => {
  switch(name) {
    case "installation":
      return {
        type: SUBMIT_INSTALLATION_DATA,
        payload: data
      };
    case "person":
      return {
        type: SUBMIT_PERSON_DATA,
        payload: data
      };
    case "contract":
      return {
        type: SUBMIT_CONTRACT_DATA,
        payload: data
      };
    case "dualGasContract":
      return {
        type: SUBMIT_DUAL_GAS_CONTRACT_DATA,
        payload: data
      };
    case "payment":
      return {
        type: SUBMIT_PAYMENT_DATA,
        payload: data
      };
    case "confirmation":
      return {
        type: SUBMIT_CONFIRMATION_DATA,
        payload: data
      };
    case "finish":
      return {
        type: SUBMIT_FINISH,
      };
  }
}

export const resetContractation = () => {
  return {
    type: RESET_CONTRACTATION
  };
};

// ----------------------------------------------------------------------------
// Gas (Dual) Contractation Form
// ----------------------------------------------------------------------------

export const setGasLeadId = (gasLeadId: number) => {
  return {
    type: SET_GAS_LEAD_ID,
    payload: gasLeadId
  }
}

// ----------------------------------------------------------------------------
// User Contractation Configuration
// ----------------------------------------------------------------------------

export const contractationConfigurationReceive = (data: ContractationConfigResponse) => {
  return {
    type: RECEIVE_CONTRACTATION_CONFIG,
    payload: data
  };
};

export const contractationDualConfigurationReceive = (data: ContractationConfigResponse) => {
  return {
    type: RECEIVE_DUAL_CONTRACTATION_CONFIG,
    payload: data
  };
};


// ----------------------------------------------------------------------------
// CUPS Information
// ----------------------------------------------------------------------------

export const confirmNewContractRequest = () => {
  return {
    type: NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST,
  };
};

export const receiveConfirmNewContractResponse = (response: IStepConfirmationResponseData) => {
  return {
    type: NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE,
    payload: {
      confirmResponse: response,
    },
  };
};

export const confirmNewContract = (data: StepConfirmationFormDataAPI) => {
  return async (dispatch: Dispatch) => {
    dispatch(confirmNewContractRequest());
    try {
      const json = await data_create_api_resource(
        null,
        "leads",
        {
          "FormConfirm": data
        }
      );
      const response = await parseJSON(json) as IStepConfirmationResponseData;
      dispatch(receiveConfirmNewContractResponse(response));
    } catch (e) {
      Sentry.captureException(e);
      if (
        Settings.electricityContractation &&
        Settings.newContract.authenticate
      ) {
        // dispatch(logoutAndRedirect(e));
      } else {
        dispatch(receiveConfirmNewContractResponse({
          result: {
            error: true,
            render: {
              format: 'markdown',
              body: i18n.t('common:text.contractation_connectivity_error')
            }
          },
          status: 'ERROR'
        }));
      }
    }      
  };
};
